import { useEffect, useState } from 'react';
import { IMAGE_ORIENTATION_CACHE } from '../utils/variables';
import { ORIENTATION } from './useImageOrientation';

// Load each image once and record { height, width, orientation } in the shared
// IMAGE_ORIENTATION_CACHE. Returns a map keyed by url; an entry appears only
// once that image's dimensions are known (failed loads record
// ORIENTATION.UNKNOWN so callers aren't left waiting forever).
export default function useImageOrientations(urls) {
  const [data, setData] = useState({});

  useEffect(() => {
    if (!urls) return;

    urls.filter((url) => !!url).forEach((url) => {
      const record = (entry) => {
        IMAGE_ORIENTATION_CACHE[url] = entry;
        setData((prev) => (prev[url] === entry ? prev : { ...prev, [url]: entry }));
      };

      if (IMAGE_ORIENTATION_CACHE[url]) {
        record(IMAGE_ORIENTATION_CACHE[url]);
        return;
      }

      const img = new Image();

      img.onload = () => {
        const { height, width } = img;
        // >= : a square backdrop belongs with the portraits — it fits a
        // vertical print slot, and the strict > classified it landscape.
        const orientation = height >= width ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE;

        record({ height, orientation, width });
      };

      // Session-local only — a failed probe is usually a transient network
      // error, and writing UNKNOWN to the shared cache would poison every
      // later consumer for the whole session. The next mount retries.
      img.onerror = () => {
        const entry = { orientation: ORIENTATION.UNKNOWN };
        setData((prev) => (prev[url] ? prev : { ...prev, [url]: entry }));
      };

      img.src = url;
    });
  }, [urls && urls.join(',')]);

  return data;
}
